import React, { useEffect, useState } from "react";
import { QuestionsIF } from "./QuestionsIF";
import { ClosedMultipleQuestion } from "./ClosedMultipleQuestion";
import { ClosedSingleQuestion } from "./ClosedSingleQuestion";
import { DocQuestion } from "./DocQuestion";
import styled from "@mui/material/styles/styled";
import { useTranslate } from "../../hooks/useTranslate";
import { ThreeDotsLoader } from "fe-web-components/loader/threeDotsLoader";
import { RefinementQuestion } from "./refinementQuestion";
import { useNavigation } from "../../state/navigationContext";
import { PatientColorMap } from "../../layout/patientColorMap";
import { RangeQuestion } from "./rangeQuestions/rangeQuestion";
import { isFreeTextSuggestion } from "fe-common/logic/qualifiedFeature/freeText";
import { FreeTextQuestion } from "./FreeTextQuestion";
import { Relations } from "shared";

//region [[ Styles ]]
const DocQuestionContainer = styled("div")({
  marginBottom: "10px",
});
//endregion [[ Styles ]]

//region [[ Props ]]

export interface ClosedQuestionQuestionProps extends QuestionsIF {
  isEntropy?: boolean;
}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]
const numericRefinementRelations = [Relations.FREQUENCY, Relations.DURATION];
export function ClosedQuestion(props: ClosedQuestionQuestionProps) {
  const { translate } = useTranslate();

  const { setViewChanged } = useNavigation();

  const isSingleSuggestion = props.question?.suggestions?.length === 1;

  const firstSuggestion = props.question.suggestions?.[0];
  const firstRefinements = firstSuggestion?.refinements;
  const firstRelation =
    firstSuggestion?.suggestion?.qualifiers?.[0]?.relation?.id;

  const isRefinement =
    isSingleSuggestion &&
    (firstRefinements?.length ||
      numericRefinementRelations.includes(firstRelation as Relations));

  const hasRange = props.question.suggestions?.[0]?.refinementLocationRange;

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (props.isEntropy) {
      setLoading(true);
      setTimeout(() => {
        setLoading(false);
        setViewChanged(true);
      }, 200);
    }
  }, [props.isEntropy, setViewChanged]);

  const getQuestionElement = () => {
    if (hasRange) {
      return <RangeQuestion {...props} />;
    }

    if (isRefinement) {
      return <RefinementQuestion {...props} />;
    }

    if (isSingleSuggestion) {
      return (
        <ClosedSingleQuestion
          {...props}
          canSkip={props.question.suggestions[0].canBeUnknown || props.canSkip}
        />
      );
    }

    return <ClosedMultipleQuestion {...props} />;
  };

  // Free text question
  if (isFreeTextSuggestion(firstSuggestion)) {
    return (
      <FreeTextQuestion
        miniView={props.miniView}
        questionText={props.question.question.text}
        answer={props.answer}
        onAnswer={props.onAnswer}
        question={props.question}
        previousAnswer={props.previousAnswer}
        isFreeTextSuggestion
      />
    );
  }

  return (
    <>
      {props.isEntropy === true && (
        <DocQuestionContainer>
          <DocQuestion
            text={translate("ENTROPY_QUESTION_START")}
            miniView={props.miniView}
          />
        </DocQuestionContainer>
      )}
      {loading && <ThreeDotsLoader color={PatientColorMap.Primary} />}
      {!loading && getQuestionElement()}
    </>
  );
}
